import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/template/index.scss";
import "./assets/Admin/global.scss";
import "./assets/responsive.scss";

import { Route, Routes } from "react-router-dom";

import AdminRoute from "./utils/security/AdminRoute";
import BlogAdd from "./pages/BlogAdd";
import BlogList from "./pages/BlogList";
import Dashboard from "./pages/Dashboard";
import ErrorPage from "./pages/ErrorPage";
import Login from "./pages/Login";
import { ToastContainer } from "react-toastify";
import { locationPath } from "./constants/appRoutes";
import { useSelector } from "react-redux";
import ChannelAdd from "./pages/ChannelAdd";
import ChannelList from "./pages/ChannelList";
import AdministratorAdd from "./pages/AdministratorAdd";
import AdministratorList from "./pages/AdministratorList";
import RoleAdd from "./pages/RoleAdd";
import RoleList from "./pages/RoleList";
import UserAdd from "./pages/UserAdd";
import UserList from "./pages/UserList";
import SliderAdd from "./pages/SliderAdd";
import SliderList from "./pages/SliderList";
import CourseAdd from "./pages/CourseAdd";
import CourseList from "./pages/CourseList";
import VideoAdd from "./pages/VideoAdd";
import VideoList from "./pages/VideoList";
import ProductAdd from "./pages/ProductAdd";
import ProductList from "./pages/ProductList";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { checkAuth } from "./actions/security";
import AuthSplash from "./components/Admin/Reusable/AuthSplash";
import CategoryAdd from "./pages/CategoryAdd";
import CategoryList from "./pages/CategoryList";
import TagAdd from "./pages/TagAdd";
import TagList from "./pages/TagList";
import SectionAdd from "./pages/SectionAdd";
import SectionList from "./pages/SectionList";
import ReelsAdd from "./pages/ReelsAdd";
import ReelsList from "./pages/ReelsList";
import ReceiptList from "./pages/ReceiptList";
import ReceiptDetail from "./pages/ReceiptDetail";
import ContactList from "./pages/ContactList";
import ContactDetail from "./pages/ContactDetail";
import EducatorContactList from "./pages/EducatorContactList";
import EducatorContactDetail from "./pages/EducatorContactDetail";
import TotalSalesDetail from "./pages/TotalSalesDetail";
import PagesList from "./pages/PagesList";
import PagesAdd from "./pages/PagesAdd";
import ReelsStatistic from "./pages/ReelsStatistic";

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated, checking, hasChecked } = useSelector(
    (state) => state.loggedUserReducer
  );

  useEffect(() => {
    if (!hasChecked) {
      dispatch(checkAuth());
    }
  }, [dispatch, hasChecked]);

  return (
    <>
      <Routes>
        {isAuthenticated ? (
          <Route
            exact
            path={"/"}
            element={<AdminRoute component={Dashboard} />}
          ></Route>
        ) : (
          <Route path="/" element={<Login />} />
        )}

        <Route
          exact
          path={locationPath.DASHBOARD}
          element={<AdminRoute component={Dashboard} />}
        ></Route>

        <Route
          exact
          path={"/blog-list"}
          element={<AdminRoute component={BlogList} />}
        ></Route>
        <Route
          exact
          path={"/blog-add"}
          element={<AdminRoute component={BlogAdd} />}
        ></Route>
        <Route
          exact
          path={"/blog-edit/:id"}
          element={<AdminRoute component={BlogAdd} />}
        ></Route>
        <Route
          exact
          path={"/channel-add"}
          element={<AdminRoute component={ChannelAdd} />}
        ></Route>
        <Route
          exact
          path={"/channel-list"}
          element={<AdminRoute component={ChannelList} />}
        ></Route>
        <Route
          exact
          path={"/channel-edit/:id"}
          element={<AdminRoute component={ChannelAdd} />}
        ></Route>
        <Route
          exact
          path={"/administrator-add"}
          element={<AdminRoute component={AdministratorAdd} />}
        ></Route>
        <Route
          exact
          path={"/administrator-list"}
          element={<AdminRoute component={AdministratorList} />}
        ></Route>
        <Route
          exact
          path={"/administrator-edit/:id"}
          element={<AdminRoute component={AdministratorAdd} />}
        ></Route>
        <Route
          exact
          path={"/role-add"}
          element={<AdminRoute component={RoleAdd} />}
        ></Route>
        <Route
          exact
          path={"/role-list"}
          element={<AdminRoute component={RoleList} />}
        ></Route>
        <Route
          exact
          path={"/role-edit/:id"}
          element={<AdminRoute component={RoleAdd} />}
        ></Route>
        <Route
          exact
          path={"/user-add"}
          element={<AdminRoute component={UserAdd} />}
        ></Route>
        <Route
          exact
          path={"/user-list"}
          element={<AdminRoute component={UserList} />}
        ></Route>
        <Route
          exact
          path={"/user-edit/:id"}
          element={<AdminRoute component={UserAdd} />}
        ></Route>
        <Route
          exact
          path={"/slider-add"}
          element={<AdminRoute component={SliderAdd} />}
        ></Route>
        <Route
          exact
          path={"/slider-list"}
          element={<AdminRoute component={SliderList} />}
        ></Route>
        <Route
          exact
          path={"/slider-edit/:id"}
          element={<AdminRoute component={SliderAdd} />}
        ></Route>
        <Route
          exact
          path={"/course-add"}
          element={<AdminRoute component={CourseAdd} />}
        ></Route>
        <Route
          exact
          path={"/course-list"}
          element={<AdminRoute component={CourseList} />}
        ></Route>
        <Route
          exact
          path={"/course-edit/:id"}
          element={<AdminRoute component={CourseAdd} />}
        ></Route>
        <Route
          exact
          path={"/video-add"}
          element={<AdminRoute component={VideoAdd} />}
        ></Route>
        <Route
          exact
          path={"/video-list"}
          element={<AdminRoute component={VideoList} />}
        ></Route>
        <Route
          exact
          path={"/video-edit/:id"}
          element={<AdminRoute component={VideoAdd} />}
        ></Route>
        <Route
          exact
          path={"/product-add"}
          element={<AdminRoute component={ProductAdd} />}
        ></Route>
        <Route
          exact
          path={"/product-list"}
          element={<AdminRoute component={ProductList} />}
        ></Route>
        <Route
          exact
          path={"/product-edit/:id"}
          element={<AdminRoute component={ProductAdd} />}
        ></Route>
        <Route
          exact
          path={"/category-add"}
          element={<AdminRoute component={CategoryAdd} />}
        ></Route>
        <Route
          exact
          path={"/category-list"}
          element={<AdminRoute component={CategoryList} />}
        ></Route>
        <Route
          exact
          path={"/category-edit/:id"}
          element={<AdminRoute component={CategoryAdd} />}
        ></Route>
        <Route
          exact
          path={"/tag-add"}
          element={<AdminRoute component={TagAdd} />}
        ></Route>
        <Route
          exact
          path={"/tag-list"}
          element={<AdminRoute component={TagList} />}
        ></Route>
        <Route
          exact
          path={"/tag-edit/:id"}
          element={<AdminRoute component={TagAdd} />}
        ></Route>
        <Route
          exact
          path={"/section-add"}
          element={<AdminRoute component={SectionAdd} />}
        ></Route>
        <Route
          exact
          path={"/section-list"}
          element={<AdminRoute component={SectionList} />}
        ></Route>
        <Route
          exact
          path={"/section-edit/:id"}
          element={<AdminRoute component={SectionAdd} />}
        ></Route>
        <Route
          exact
          path={"/reels-add"}
          element={<AdminRoute component={ReelsAdd} />}
        ></Route>
        <Route
          exact
          path={"/reels-list"}
          element={<AdminRoute component={ReelsList} />}
        ></Route>
        <Route
          exact
          path={"/reels-edit/:id"}
          element={<AdminRoute component={ReelsAdd} />}
        ></Route>
        <Route
          exact
          path={"/receipt-list"}
          element={<AdminRoute component={ReceiptList} />}
        ></Route>
        <Route
          exact
          path={"/receipt-edit/:id"}
          element={<AdminRoute component={ReceiptDetail} />}
        ></Route>
        <Route
          exact
          path={"/contact-list"}
          element={<AdminRoute component={ContactList} />}
        ></Route>
        <Route
          exact
          path={"/contact-edit/:id"}
          element={<AdminRoute component={ContactDetail} />}
        ></Route>
        <Route
          exact
          path={"/educator-contact-list"}
          element={<AdminRoute component={EducatorContactList} />}
        ></Route>
        <Route
          exact
          path={"/educator-contact-edit/:id"}
          element={<AdminRoute component={EducatorContactDetail} />}
        ></Route>
        <Route
          exact
          path={"/total-sales-detail-list"}
          element={<AdminRoute component={TotalSalesDetail} />}
        ></Route>
        <Route
          exact
          path={"/pages-list"}
          element={<AdminRoute component={PagesList} />}
        ></Route>
        <Route
          exact
          path={"/pages-edit/:id"}
          element={<AdminRoute component={PagesAdd} />}
        ></Route>
        <Route
          exact
          path={"/reels-statistics"}
          element={<AdminRoute component={ReelsStatistic} />}
        ></Route>

        <Route path="*" element={<AdminRoute component={ErrorPage} />} />
      </Routes>
      <ToastContainer />
    </>
  );
}

export default App;
